export default {"src":"/_next/static/media/img-landing-hero-bg-1.1d8a163b.svg","height":524,"width":530,"blurWidth":0,"blurHeight":0};